import { useState } from "react";
import CnpjUtils from "../../../shared/utils/CnpjUtils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import { formatContractCyclesResponse } from "../utils/dashboard-cycle-list-utils";

export function useDashboardContractCycles() {
	const [contractCycles, setContractCycles] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchContractCycles = async ({
		document,
		contractId
	}) => {
		const cleanDocument = CnpjUtils.cleanAlphanumericCnpj(document || "");

		if (!cleanDocument || !contractId) {
			const message = "Informe o documento do cliente e o contrato.";

			setContractCycles([]);
			setError(message);

			return {
				ok: false,
				error: message
			};
		}

		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-dashboard/v1/dashboard/clientes/${cleanDocument}/contratos/${contractId}/ciclos`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar os ciclos do contrato."
				);
			}

			const data = await response.json();
			const formattedCycles = formatContractCyclesResponse(data);

			setContractCycles(formattedCycles);
			setError(null);

			return {
				ok: true,
				contractCycles: formattedCycles
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message ||
				"Não foi possível carregar os ciclos do contrato.";

			setContractCycles([]);
			setError(errorMessage);

			return {
				ok: false,
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	};

	const clearContractCycles = () => {
		setContractCycles([]);
		setError(null);
	};

	return {
		contractCycles,
		contractCyclesLoading: loading,
		contractCyclesError: error,
		fetchContractCycles,
		clearContractCycles
	};
}